<template>
  <div>
    <v-expansion-panels v-model="expandedArray">
      <v-expansion-panel class="grey lighten-3">
        <v-expansion-panel-header>
          <span>
            <strong>{{ $t("delegation.form.additionalOtherCost") }} </strong>
            <span>
              <b class="green--text">{{ count }}</b>
            </span>
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="grey lighten-5">
          <simple-other-summary-list v-on:removeOtherItem="removeOther" :clearable="clearable && !readonly" :model-other.sync="contextOther" class="px-3" />
          <v-btn v-if="addable && !readonly" color="accent" v-on:click="addOther()">{{ $t("global.add") }}</v-btn>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import SimpleOtherSummaryList from "./SimpleOtherSummaryList.vue";

export default {
  name: "CollapseOtherSummaryPanel",
  components: { SimpleOtherSummaryList },
  data: () => ({
    expandedArray: false
  }),
  props: {
    readonly: {
      required: false,
      default: false
    },
    modelOther: {
      required: true
    },
    clearable: {
      required: false,
      default: false
    },
    addable: {
      required: false,
      default: true
    }
  },
  watch: {
    expanded: function(value) {
      if (value === true) {
        if (this.count === 0) {
          // add new on panel expand
          this.addOther();
        }
      } else {
        // clean empty
        for (let index = this.modelOther.length - 1; index >= 0; index--) {
          let other = this.modelOther[index];
          if (
            other.id === null &&
            (other.amount_in_currency == null || other.amount_in_currency.length < 1) &&
            other.file_id == null &&
            other.type_id == null &&
            other.payment_type_id == null &&
            other.bill_number == null &&
            other.bill_date == null &&
            other.type === "summary" &&
            other.bill_description == null
          ) {
            this.removeOther(other);
          }
        }
      }
    }
  },
  methods: {
    removeOther(item) {
      this.$store.dispatch("Delegation/removeOther", item);
    },
    addOther() {
      if (!this.readonly) {
        this.$store.dispatch("Delegation/addOther", "summary");
      }
    }
  },
  computed: {
    contextOther: {
      set(value) {
        this.$emit("update:modelOther", value);
      },
      get() {
        return this.modelOther;
      }
    },
    count() {
      let howMany = 0;
      for (let index = this.modelOther.length - 1; index >= 0; index--) {
        let other = this.modelOther[index];
        if (other.type === "summary") {
          howMany++;
        }
      }
      return howMany;
    },
    expanded() {
      return typeof this.expandedArray === "number";
    }
  }
};
</script>

<style scoped></style>
